// from node_modules/bootstrap/scss/_variables $grid-breakpoints

export const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
}
